export type TSortable = 'createdAt' | 'sender' | 'user';

export const sortedFields = {
  createdAt: 'createdAt',
  sender: 'sender.username',
  user: 'user.username',
};
